var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarMetas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sidebar_calendario",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.3 32.3",
    style: {
      enableBackground: "new 0 0 32.3 32.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9F9F9;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "metas_1_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1410_1_",
    className: "st0",
    d: "M16.2,1.3c0.5,0,1,0.3,1.2,0.8l3.8,7.8l8.6,1.3c0.7,0.1,1.2,0.8,1.1,1.5 c0,0.3-0.2,0.6-0.4,0.8l-6.2,6.1l1.5,8.6c0.1,0.7-0.4,1.4-1.1,1.6c-0.3,0.1-0.6,0-0.9-0.1l-7.7-4l-7.7,4c-0.7,0.3-1.5,0.1-1.8-0.6 c-0.1-0.3-0.2-0.6-0.1-0.9L8,19.5l-6.2-6.1c-0.5-0.5-0.5-1.4,0-1.9c0.2-0.2,0.5-0.3,0.8-0.4l8.6-1.3L15,2.1 C15.2,1.6,15.6,1.3,16.2,1.3z M26.7,13.4l-6.6-1c-0.4-0.1-0.8-0.3-1-0.7l-3-6l-3,6c-0.2,0.4-0.6,0.7-1,0.7l-6.6,1l4.8,4.7 c0.3,0.3,0.5,0.8,0.4,1.2l-1.1,6.6l5.9-3.1c0.4-0.2,0.9-0.2,1.3,0l5.9,3.1l-1.1-6.6c-0.1-0.4,0.1-0.9,0.4-1.2L26.7,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411_1_",
    className: "st1",
    d: "M0,0h32.3v32.3H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMetas);
export default __webpack_public_path__ + "static/media/sidebar_metas.174b5bdbacd4f463bf209a6dae1b0b87.svg";
export { ForwardRef as ReactComponent };